import { Coordinate, Entity, HexColor } from '@nx-smartmonkey/shared/domain';
import { removeEmpty } from '@nx-smartmonkey/shared/helpers';
import { MarkerDomain } from '@nx-smartmonkey/ui';

export interface GeoFenceUpdateProps {
  label?: string;
  enabled?: boolean;
  color?: HexColor;
  coordinates?: Coordinate[][];
}

export interface GeoFenceProps {
  label: string;
  project_id: string;
  enabled: boolean;
  color: HexColor;
  coordinates: Coordinate[][];
  created_at?: Date;
  created_by?: string;
}

export class GeoFence extends Entity<GeoFenceProps> {
  get id(): string {
    return this._id!;
  }
  get label(): string {
    return this.props.label;
  }
  set label(label: string) {
    this.props.label = label;
  }
  get project_id(): string {
    return this.props.project_id;
  }
  set project_id(projectId: string) {
    this.props.project_id = projectId;
  }
  get created_at(): Date | undefined {
    return this.props.created_at;
  }
  set created_at(created_at: Date | undefined) {
    this.props.created_at = created_at;
  }
  get created_by(): string | undefined {
    return this.props.created_by;
  }
  set created_by(created_by: string | undefined) {
    this.props.created_by = created_by;
  }
  get enabled(): boolean {
    return this.props.enabled;
  }
  set enabled(enabled: boolean) {
    this.props.enabled = enabled;
  }
  get color(): HexColor {
    return this.props.color;
  }
  set color(color: HexColor) {
    this.props.color = color;
  }
  get coordinates(): Coordinate[][] {
    return this.props.coordinates;
  }
  set coordinates(coordinates: Coordinate[][]) {
    this.props.coordinates = coordinates;
  }
  update(props: GeoFenceUpdateProps) {
    removeEmpty(props);
    if (props.label !== undefined) this.props.label = props.label;
    if (props.enabled !== undefined) this.props.enabled = props.enabled;
    if (props.color !== undefined) this.props.color = props.color;
    if (props.coordinates !== undefined) this.props.coordinates = props.coordinates;
  }
  private constructor(props: GeoFenceProps, id?: string) {
    super(props, id);
  }
  static create(props: GeoFenceProps, id?: string): GeoFence {
    return new GeoFence(props, id);
  }

  /**
   * Shorten geo fence label.
   * EXAMPLES:
   * - John Doe -> JD
   * - JohnDoe -> JO
   * - J -> J
   * @returns string
   */
  getShortLabel(): string {
    let displayName: string = this.label.trim().replace(/\s{2,}/g, ` `);
    const displayNameSplit = displayName.split(` `);
    if (displayNameSplit.length > 1) {
      displayName = `${displayNameSplit[0][0]}${displayNameSplit[1][0]}`;
    } else if (displayNameSplit[0].length > 1) {
      displayName = `${displayNameSplit[0][0]}${displayNameSplit[0][1]}`;
    }
    return displayName.toLocaleUpperCase();
  }

  isMarkerInsideGeoFence(markerCoords: { lat: number; lng: number }) {
    return this.coordinates.some((coordinates) => {
      return MarkerDomain.isMarkerInsideCoordinates({
        markerCoords,
        coordinates: coordinates.map((c) => c.toObject()),
      });
    });
  }

  coordinatesToArray(): [number, number][][] {
    return this.coordinates.map((coordinate) => coordinate.map((c) => c.toArray()));
  }

  coordinatesToObject(): { lat: number; lng: number }[][] {
    return this.coordinates.map((coordinate) => coordinate.map((c) => c.toObject()));
  }
}
